import {
  RESERVATIONS_TYPES,
  AVAILABILITY_STATUSES,
  PROCUREMENT_STAGES,
} from '@constants';

export const getTabSalesReservationType = (reservationsTypes) => {
  if (!reservationsTypes?.length) return [];

  return reservationsTypes.filter(
    (item) =>
      item.value === RESERVATIONS_TYPES.free.value ||
      item.value === RESERVATIONS_TYPES.onhold.value
  );
};

export const getTabSalesStatus = (statuses) => {
  if (!statuses?.length) return [];

  return statuses.filter(
    (status) => status.value === AVAILABILITY_STATUSES.available.value
  );
};

export const getTabSalesProcurementStage = (procurementStages) => {
  if (!procurementStages?.length) return [];

  return procurementStages.filter(
    (stage) => stage.value === PROCUREMENT_STAGES.FLEET
  );
};
